import { Component, HostListener, ViewChild, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { PagerService } from '@app/services/pager.service';
import { CommonService } from '@app/services/common.service';
import { Helper } from '../../../../../4services/2helper'
import { c_components } from 'src/3ui/2components';
import ims from '../../../imports'
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'c_dtable_incident_reports_manager',
    templateUrl: './c_dtable_incident_reports_manager.component.html',
    styleUrls: ['../../common.scss', './c_dtable_incident_reports_manager.component.scss'],
    standalone: false
})
export class c_dtable_incident_reports_manager_component extends BaseComponent {
  @ViewChild('siteSelect') siteSelect: ElementRef;
  @ViewChild('visibilitySelect') visibilitySelect: ElementRef;
  @ViewChild('typeSelect') typeSelect: ElementRef;
  @ViewChild('categorySelect') categorySelect: ElementRef;
  @ViewChildren('actionMenus') actionMenus: QueryList<any>
//-----------------------------------------------------------------------------
  isLoading = false;
  isPDFDownloadLoading = false;
  tableHeader = [
    { name: '', value: null, width: "3%" },
    { name: 'Site Name', value: 'site_name', width: "13%" },
    { name: 'Dealer Name', value: 'dealer_name', width: "13%" },
    { name: 'Date Created', value: 'created_at', width: "12%" },
    { name: 'Created By', value: 'created_by', width: "11%" },
    { name: 'Report Name (Event Occur)', value: null, width: "20%" },
    { name: 'Type', value: 'type', width: "10%" },
    { name: 'Sub-Category', value: 'category', width: "10%" },
    { name: '', value: null, width: "5%" },
  ]

  // permission
  hasReadIncidentReportPermission = false;
  hasCreateIncidentReportPermission = false;
  hasSharedIncidentReportPermission = false;
  hasDeleteIncidentReportPermission = false;
  hasUpdateIncidentReportVisiblityPermission = false;

  // list
  filteredReportList = [];
  originalReportList = [];
  sitePartners = [];
  pagedItems = [];

  isFocusSearch = false;
  searchText = '';

  // filter - site
  isUnfoldSiteListDropdown = false;
  siteList = [];
  filteredSiteList = [];
  searchSiteTxt = '';
  selectedSite = null;

  // filter - visibility
  isUnfoldVisibilityListDropdown = false;
  visibilityList = [ 
    { label: 'Internal Report', value: 0, isSelected: true }, 
    { label: 'Publish to Customer', value: 1, isSelected: true} 
  ];
  selectedVisibilityList = this.visibilityList.filter(v=>v.isSelected)
  originalVisibilityList = this.selectedVisibilityList
  selectedVisibilityListLabels = 'All'

  // filter - Incident Type
  isUnfoldIncidentTypeDropdown = false;
  incidentTypeList = [];
  filteredTypeList = [];
  searchTypeTxt = '';
  selectedIncidentType = null;

  // filter - category
  isUnfoldIncidentCategoryDropdown = false;
  incidentCategoryList = [];
  filteredCategoryList = [];
  searchCategoryTxt = '';
  selectedIncidentCategory = null;

  // Pager
  pager: any = {};
  curPage = 1;
  totalItem = 0;
  pageOffset = 20;
  pageOffsetStart = 1;
  pageOffsetEnd = 1;
  lastPage = 1;

  constructor(
    public pagerService : PagerService,
    public commonService: CommonService,
    public c_components: c_components,
    public helper: Helper,
  ) { super(); }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (this.actionMenus) {
      const actionMenus = this.actionMenus.toArray();
      actionMenus.forEach(actionMenu => {
        this.pagedItems.forEach(report=> {
          if (report.id + '' === actionMenu.nativeElement.id) {
            if (!actionMenu.nativeElement.contains(event.target)) {
              report.isShowMenu = false;
            }
          }
        })
      })
    }
    if (this.siteSelect) {
      if (!this.siteSelect.nativeElement.contains(event.target)) {
        event.stopPropagation()
        this.isUnfoldSiteListDropdown = false;
        this.searchSiteTxt = '';
      }
    }
    if (this.visibilitySelect) {
      if (!this.visibilitySelect.nativeElement.contains(event.target)) {
        event.stopPropagation()
        this.isUnfoldVisibilityListDropdown = false;
        this.searchSiteTxt = '';
      }
    }
    if (this.typeSelect) {
      if (!this.typeSelect.nativeElement.contains(event.target)) {
        event.stopPropagation()
        this.isUnfoldIncidentTypeDropdown = false;
        this.searchTypeTxt = '';
      }
    }
    if (this.categorySelect) {
      if (!this.categorySelect.nativeElement.contains(event.target)) {
        event.stopPropagation()
        this.isUnfoldIncidentCategoryDropdown = false;
        this.searchCategoryTxt = '';
      }
    }
  }

  async ngOnInit() {
    await this.fetchData();
    this.setPage(1)
  }

  async fetchData(){
    this.isLoading = true;
    await this.checkPermission();
    if(!this.hasReadIncidentReportPermission) {
      this.setPage(1);
      return;
    }

    await this.getSitePartners();
    await this.getSiteList();
    await this.getIncidentTypeList();
    await this.getIncidentReportList();
  }

  async checkPermission(){
    await this.helper.permission.load_my_permissions_only_if_not_loaded();
    this.hasReadIncidentReportPermission = this.helper.permission.has("dealer_site_incident_report_read")
    this.hasCreateIncidentReportPermission = this.helper.permission.has("dealer_site_incident_report_create")
    this.hasSharedIncidentReportPermission = this.helper.permission.has("dealer_site_incident_report_share")
    this.hasDeleteIncidentReportPermission = this.helper.permission.has("dealer_site_incident_report_delete")
    this.hasUpdateIncidentReportVisiblityPermission = this.helper.permission.has("dealer_site_create_published_report")
  }

  async getSitePartners(){
    try {
      this.sitePartners = await this.helper.dealer.get_site_partners()
    } catch(err) {
      this.sitePartners = [];
      this.isLoading = false;
    }
  }
  async getSiteList(){
    try{
      this.siteList = await this.helper.sites.get_sites();
      this.filteredSiteList = ims._.cloneDeep(this.siteList);
    } catch(err) {
      this.isLoading = false;
    }
  }
  async getIncidentTypeList(){
    try {
      this.incidentTypeList = await this.helper.incident_reports.get_incident_types();
      this.filteredTypeList = ims._.cloneDeep(this.incidentTypeList)
    } catch(err) {
      this.isLoading = false;
      this.incidentTypeList = []
      this.filteredTypeList = []
    }
  }
  async getIncidentReportList(){
    try {
      const list = await this.helper.incident_reports.get_dealer_incident_reports()
      this.parseIncidentReportList(list)
    } catch(err) {
      this.isLoading = false;
    }
  }
  
  async refresh(){
    this.isLoading = true;
    await ims.tool.sleep(100)
    await this.helper.incident_reports.load_dealer_incident_reports();
    const list = this.helper.incident_reports.dealer_incident_reports();
    this.parseIncidentReportList(list)
    this.setPage(1);
    this.isLoading = false;
  }

  parseIncidentReportList(list){
    list.forEach(report => { 
      report['isShowMenu'] = false;
      report['dealer_name'] = this.parseDealerName(report)
      report['name'] = report['name'] ?? this.parseEventOccur(report)
      report['access_status'] = this.setAccessStatusValue(report);
      report['type'] = this.parseIncidentType(report);
      report['created_date'] = ims.moment(report?.created_at).tz(report?.timezone).format('MMM/DD/YYYY, hh:mm A')
    })

    list.sort((a, b) => this.compare(a.created_at, b.created_at, false))
    this.originalReportList = ims._.cloneDeep(list);
    this.filteredReportList = ims._.cloneDeep(list);
    this.filteredCategoryList = ims._.cloneDeep(this.incidentCategoryList);
  }

  parseDealerName(report){
    return this.sitePartners.find(v => v.dealer_id == report.site_dealer_id)?.internal_sub_dealer_id_with_company_name
  }
  parseEventOccur(report){
    const eventStartTime = this.parseEventTime(report.event_start_time, report.timezone)
    const eventEndTime = this.parseEventTime(report.event_end_time, report.timezone)
    return `${eventStartTime} - ${eventEndTime}`
  }
  parseEventTime(time: string, timezone: string){
    if(!time) return ''
    if(!timezone) return ims.moment(time).format('DD MMM YYYY, hh:mm:ss a')
    return ims.moment(time).tz(timezone).format('DD MMM YYYY, hh:mm:ss a')
  }
  setAccessStatusValue(report){
    // CASE 1(FAILD): red - pdf_generation_status = 2
      // 혹은 생성된지 5분이 지났는데 pdf_generation_status = 0 인 경우
    // CASE 2(PENDING): orange - pdf_generation_status = 0 
    // CASE 3(NOT ACCESS in EAU): gray - is_visible_in_end_user_app = false && pdf_generation_status = 1
    // CASE 4(ACCESS in EAU): gray - is_visible_in_end_user_app = true && pdf_generation_status = 1 
    if(report.pdf_generation_status === 2) return 1;
    if(report.pdf_generation_status === 0) { 
      return this.isPass5Mins(report) ? 1 : 2;
    }
    if(report.pdf_generation_status === 1) {
      return report.is_visible_in_end_user_app ? 4 : 3;
    }
    return 3; // default
  }
  isPass5Mins(report){
    const created = report.created_at;
    const now = ims.moment()
    return ims.moment(now).diff(created, 'minute') >= 5
  }
  parseIncidentType(report){
    if(!report.incident_type_id) return ''
    const result = this.incidentTypeList.find(v => v.id == report.incident_type_id)
    return result?.name ?? ''
  }
  // --------------------------------------------------------------------------------
  // FILTER
  // CASE 1) SITE
  selectSite(site){
    this.selectedSite = site
    this.isUnfoldSiteListDropdown = false
    this.searchSiteTxt = ''
    this.doFilter()
  }
  searchSite(searchSiteTxt) {
    this.filteredSiteList = this.siteList.filter(site => site.name.toLowerCase().indexOf(searchSiteTxt.toLowerCase()) > -1);
  }

  clearSiteFilter(){
    this.searchSiteTxt = ''
    this.selectedSite = null
    this.filteredSiteList = this.siteList
    this.doFilter()
  }

  // CASE 2) STATUS
  selectVisibility(event, visibility){
    event.stopPropagation();
    visibility.isSelected = !visibility.isSelected
    
    this.selectedVisibilityList = this.visibilityList.filter(v=>v.isSelected)
    this.originalVisibilityList = this.selectedVisibilityList
    this.computedSelectedVisibilityLabels()
    this.doFilter()
  }
  computedSelectedVisibilityLabels(){
    this.visibilityList.every(v => v.isSelected) || this.visibilityList.every(v => !v.isSelected)
      ? this.selectedVisibilityListLabels = 'All'
      : this.selectedVisibilityListLabels = this.selectedVisibilityList.map(v=>v.label).join(', ')
  }
  clearVisibilityFilter(){
    this.visibilityList.forEach(v => v.isSelected = true)
    this.selectedVisibilityList = this.visibilityList.filter(v=>v.isSelected)
    this.originalVisibilityList = this.selectedVisibilityList
    this.selectedVisibilityListLabels = 'All'
    this.doFilter()
  }

  // CASE 3) TYPE
  selectType(type){
    this.selectedIncidentType = type
    this.isUnfoldIncidentTypeDropdown = false
    this.searchTypeTxt = ''

    this.incidentCategoryList = type?.incident_categories ?? []
    this.filteredCategoryList = type?.incident_categories ?? []
    this.doFilter()
  }
  searchType(searchTypeTxt) {
    this.filteredTypeList = this.incidentTypeList.filter(type => type.name.toLowerCase().indexOf(searchTypeTxt?.toLowerCase()) > -1);
  }

  clearTypeFilter(){
    this.searchTypeTxt = ''
    this.selectedIncidentType = null
    this.filteredTypeList = this.incidentTypeList
    this.clearCategoryFilter();
    this.doFilter()
  }

  // CASE 4) CATEGORY
  selectCategory(category){
    this.selectedIncidentCategory = category
    this.isUnfoldIncidentCategoryDropdown = false
    this.searchTypeTxt = ''
    this.doFilter()
  }
  searchCategory(searchCategoryTxt) {
    this.filteredCategoryList = this.incidentCategoryList.filter(category => category.name.toLowerCase().indexOf(searchCategoryTxt.toLowerCase()) > -1);
  }

  clearCategoryFilter(){
    this.searchCategoryTxt = ''
    this.selectedIncidentCategory = null
    this.filteredCategoryList = this.incidentCategoryList
    this.doFilter();
  }

  // Let's do filtering
  doFilter(){
    if(!this.originalReportList?.length) return;

    const target = ims._.cloneDeep(this.originalReportList)
    this.filteredReportList = target.filter(item => {
      const siteMatch = !this.selectedSite || this.selectedSite.site_id === item.site_id
      const visibilityMatch = this.computedVisiblityMatch(item);
      const typeMatch = !this.selectedIncidentType || this.selectedIncidentType.id === item.incident_type_id
      const categoryMatch = !this.selectedIncidentCategory || this.selectedIncidentCategory.name === item.category
  
      return siteMatch && visibilityMatch && typeMatch && categoryMatch;
    });

    this.setPage(1);
  }
  computedVisiblityMatch(item): boolean{
    if(this.selectedVisibilityList?.length === 0) return true;
    
    const noVisiblityFitler = this.selectedVisibilityList.findIndex(v => v.value === 0)
    const hasVisiblityFitler = this.selectedVisibilityList.findIndex(v => v.value === 1)
    if(noVisiblityFitler > -1) {
      return !item.is_visible_in_end_user_app
    }
    if(hasVisiblityFitler > -1) {
      return item.is_visible_in_end_user_app
    }
    return false;
  }


  // --------------------------------------------------------------------------------
  setMorePosition(report){
    const docElem = document.documentElement
    let elem = document.getElementById(report?.id);
    let more = document.getElementById('more-'+report?.id);
    let rect = elem.getBoundingClientRect();
    const posX = docElem.clientWidth - rect.right - 15
    const posY = rect.top - 30;
    more.style.right = posX + 'px';
    more.style.top = posY + 'px';
  }
  setTooltipPosition(e) {
    e.stopPropagation();
    const docElem = document.documentElement
    let elem = e.currentTarget;
    let more = elem.querySelector('.--g-tooltip');
    let rect = elem.getBoundingClientRect();
    const posX = docElem.clientWidth - rect.right - 120
    const posY = rect.top - 30;
    more.style.right = posX + 'px';
    more.style.top = posY + 'px';
  }

  toggleMenu(report){
    const targetMenu = report.isShowMenu;
    report.isShowMenu = !targetMenu;
  }

  toggletypeSelect(e){
  e?.stopPropagation()
    this.isUnfoldIncidentTypeDropdown = !this.isUnfoldIncidentTypeDropdown
  }

  selectIncidentType(event, type){
    event?.stopPropagation();
    this.selectedIncidentType = type;
  }

  // STYLES
  determineElementToShow(){
    if(!this.hasReadIncidentReportPermission) return 'no-permission'
    if(!this.pagedItems?.length) return 'no-data'
    return 'normal'
  } 

  computedAccessBadgeStyleClass(report){
    if(report?.is_visible_in_end_user_app === 0) return 'not-access';
    if(report?.is_visible_in_end_user_app === 1) return 'access';
  }

  computedAccessBadgeTooltip(report){
    const value = report?.is_visible_in_end_user_app
    switch(value){
      case(0): return 'Internal Report';
      case(1): return 'Publish to Customer';
      default: return '';
    }
  }

  // -----------------------------------------------------------------------------
  // ACTION
  goToDetail(event, report){
    event.stopPropagation();
    if(!report) return;
    const url = `/customers/report/incident-report/${report.id}`;
    this.commonService.emitSiteTab([{targetUrl: url, targetReportId: report.id, name: 'Reports', link: 'report/incident-report'}, 'incident-report'])
    this.helper.router.navigate_to(url, {id: report.site_id});
  }

  async downloadPDF(report){
    try {
      this.isPDFDownloadLoading = true
      const pdfFile:Blob = await this.helper.incident_reports.download_incident_report_pdf(report.site_id, report.id)
      const siteName = `[Security Incident Report] - ${ report.site_name }`
      const startDate = report.event_start_time
      const occurDate = ims.moment(startDate).tz(report.timezone).format('DD MMM YYYY')
      const filename = `${siteName} - ${occurDate}.pdf`;
  
      let fileURL = URL.createObjectURL(pdfFile);
      let a         = document.createElement('a');
      a.href        = fileURL;
      a.target      = '_blank';
      a.download    = filename;
      document.body.appendChild(a);
      this.isLoading = false
      a.click();
      this.isPDFDownloadLoading = false
      document.body.removeChild(a);
    } catch(err) {
      this.isPDFDownloadLoading = false
      console.debug(err)
      this.commonService.showErrorToast('Download Report', 'Failed to download report.') 
    }
  }

  openShareDialog(report){
    this.c_components.dialog.open("share_incident_report_email", {report})
  }

  openLogOfSharingDialog(report){
    this.c_components.dialog.open("share_incident_report_log", {report})
  }

  async changeVisibilityInEndUserApp(event, report){
    event?.stopPropagation();
    if(!report) return
    const value = !report.is_visible_in_end_user_app ? 1 : 0
    try {
      const data = {
        is_visible_in_end_user_app: value,
        should_update_pdf_url: 0
      }
      await this.helper.incident_reports.update_incident_report(report.site_id, report.id, data)
      await this.refresh();
      this.commonService.showSuccessToast('Update Incident Report', 'Successfully updated.')
    } catch(err) {
      console.debug('changeVisibilityInEndUserApp:>',err)
      this.commonService.showErrorToast('Update Incident Report', 'Failed to update.')
    }
  }

  openDeleteDialog(e, report){ 
    e.stopPropagation();
    this.c_components.dialog.open("warning", {
      header: `Do you want to delete this report?`,
      contents: ``,
      submit_btn: "Delete",
      submit_class: ["button-danger"],
      icon: 'warning',
      isConfirm: false,
      color: 'orange',
      submit_func: async () => {
        await this.deleteReport(report)
      },
    });
  }

  async deleteReport(report){
    try {
      const siteId = report.site_id;
      await this.helper.incident_reports.delete_incident_report(siteId, report.id);
      await this.refresh();
      this.commonService.showSuccessToast('Delete Report', 'Report has been deleted successfully.')
    } catch(err) {
      this.commonService.errorDialog(err, 'Delete Report');
    }
  }

  // -----------------------------------------------------------------------------
  compare(a: number | string | null, b: number | string | null, isAsc: boolean) {
    if (a === null && b === null) return 0; 
    if (a === null) return isAsc ? -1 : 1; 
    if (b === null) return isAsc ? 1 : -1; 
    
    if (typeof a === 'string') a = a.toLocaleLowerCase();
    if (typeof b === 'string') b = b.toLocaleLowerCase();
    
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortTableByColumn(sortTarget) {
    if (!sortTarget.sortColumn || sortTarget.sortDirection === '') {
      return;
    }
    let data = this.filteredReportList;

    const tmpData = data.sort((a, b) => {
      const isAsc = sortTarget.sortDirection === 'asc';
      switch (sortTarget.sortColumn) {
        case 'created_at': return this.compare(a?.created_at, b?.created_at, isAsc);
        case 'created_by': return this.compare(a?.created_by, b?.created_by, isAsc);
        case 'startAt': return this.compare(a?.event_start_time, b?.event_start_time, isAsc);
        case 'endAt': return this.compare(a?.event_end_time, b?.event_end_time, isAsc);
        case 'type': return this.compare(a?.type, b?.type, isAsc);
        case 'category': return this.compare(a?.category, b?.category, isAsc);
        default: return 0;
      }
    });
    
    this.pagedItems = tmpData;
    this.setPage(1)
  }

  setPage(page: number) {
    this.pagedItems = []

    const target = this.filteredReportList
    if(!target){
      console.debug('⚠️ list is lost', target)
      return this.isLoading = false
    }
    
    // get pager object from service
    this.pager = this.pagerService.getPager(target?.length, page, this.pageOffset);
    this.totalItem = target?.length;
    
    // get current page of items
    this.pagedItems = target.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.curPage = this.pager.currentPage;
    if (this.curPage -1 < 0) {
      this.pageOffsetStart = 0;
    } else if (this.curPage -1 == 0) {
      this.pageOffsetStart = 1;
    } else {
      this.pageOffsetStart =  (this.curPage -1) * this.pageOffset +1;
    }

    if (this.curPage * this.pageOffset > this.totalItem) {
      this.pageOffsetEnd =  this.totalItem;
    } else {
      this.pageOffsetEnd =  this.curPage * this.pageOffset;
    }
    this.isLoading = false;
  }
}